import { Icon } from './Icon';
import './ThemeToggle.css';

export function ThemeToggle({ theme, onToggle, className = '' }) {
    const dark = theme === 'dark';
    return (
        <button
            type="button"
            className={`iconBtn themeToggle${dark ? ' themeToggle--dark' : ''} ${className}`}
            onClick={onToggle}
            aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
            title={dark ? 'Light theme' : 'Dark theme'}
        >
            <Icon name="sun" size={18} className="themeToggleIcon themeToggleIcon--sun" />
            <Icon name="moon" size={17} className="themeToggleIcon themeToggleIcon--moon" />
        </button>
    );
}
